import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { APP_SETTINGS } from '../../shared/models/backofficeConfiguration';
import { ExecuteService } from '../../shared/services/executeService.service';
import { ErrorHandlerService } from '../../shared/services/errorHandler.service';
import * as moment from 'moment-timezone';
import { HttpParams } from '@angular/common/http';
import { PaymentTransaction } from '../models/PaymentTransaction';
import { PaymentTransactionFilter } from '../models/PaymentTransactionFilter';


@Injectable()
export class PaymentTransactionsService {
  private apiUrl = APP_SETTINGS.PaymentTransactionApiUrl;
  private userPayApiUrl = APP_SETTINGS.UserPayApiUrl;

  constructor(
    private executeService: ExecuteService,
    private errorHandler: ErrorHandlerService) { }

  public GetByFilter(
    filter: PaymentTransactionFilter): Observable<PaymentTransaction[]> {
    const url = `${this.apiUrl}`;
    const params = this.getFilterQueryParams(filter);

    return this.executeService.ExecuteWithToken('get', url, params)
      .pipe(
        map(transactions => transactions.map(transaction => this.mapResponseItem(transaction))),
        catchError(this.errorHandler.handleError<PaymentTransaction[]>('PaymentTransactionsService_GetByFilter', [], true))
      );
  }

  public GetByFilterPay(
    filter: PaymentTransactionFilter): Observable<PaymentTransaction[]> {
    const url = `${this.userPayApiUrl}/api/v1/PaymentTransaction`;
    const params = this.getFilterQueryParams(filter);

    return this.executeService.ExecuteWithToken('get', url, params)
      .pipe(
        map(transactions => transactions.map(transaction => {
          let item = this.mapResponseItem(transaction);
          item.paymentEmail = transaction.email;
          return item;
        })),
        catchError(this.errorHandler.handleError<PaymentTransaction[]>('PaymentTransactionsService_GetByFilter', [], true))
      );
  }

  private getFilterQueryParams(filter: PaymentTransactionFilter): HttpParams {
    let params = new HttpParams()
      .set('from', filter.from.toISOString())
      .set('to', filter.to.toISOString());

    if (filter.paymentEmail) {
      params = params.set('paymentEmail', filter.paymentEmail);
    }
    if (filter.userEmail) {
      params = params.set('userEmail', filter.userEmail);
    }
    if (filter.userId) {
      params = params.set('userId', filter.userId);
    }
    if (filter.platformSubId) {
      params = params.set('platformSubId', filter.platformSubId);
    }
    if (Array.isArray(filter.paymentPlatforms)) {
      filter.paymentPlatforms.forEach(x => {
        params = params.append('paymentPlatforms', x);
      })
    }
    if (Array.isArray(filter.types)) {
      filter.types.forEach(x => {
        params = params.append('types', x);
      })
    }
    if (filter.customType) {
      params = params.append('customType', filter.customType);
    }
    if (Array.isArray(filter.productTypes)) {
      filter.productTypes.forEach(x => {
        params = params.append('productTypes', x);
      })
    }

    return params;
  }

  private mapResponseItem(x: any): PaymentTransaction {
    let result: PaymentTransaction = {
      id: x.id,
      paymentType: x.paymentType,
      dateUtc: moment(x.dateUtc),
      premiumExpirationDateUtc: x.premiumExpirationDateUtc ? moment(x.premiumExpirationDateUtc) : null,
      type: x.type,
      formattedType: x.type ? x.type.replace(/([a-z])([A-Z])/g, '$1 $2') : null,
      paymentPlatform: x.paymentPlatform,
      userId: x.userId,
      userEmail: x.userEmail,
      paymentEmail: x.paymentEmail,
      subscription: {
        id: x.subscription.id,
        name: x.subscription.name,
        months: x.subscription.months,
        productType: x.subscription.productType ? x.subscription.productType.replace(/([a-z])([A-Z])/g, '$1 $2') : null
      },
      amount: x.amount,
      details: x.details,
      platformSubId: x.platformSubId
    };

    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/paymentTransactions/services/paymentTransactions.service.ts